<template>
  <div
    v-if="isAuthenticated"
    class="layout"
    :class="{ 'layout--loading': isLoading }"
  >
    <KTHeaderMobile />

    <aside v-if="asideEnabled" class="layout__sidebar">
      <KTAside />
    </aside>

    <div class="layout__main">
      <header class="layout__header">
        <KTHeader />
      </header>

      <main class="layout__content">
        <v-app class="layout__content-app rounded-lg">
          <slot>
            <router-view />
          </slot>
        </v-app>
      </main>

      <footer class="layout__footer zindex-5">
        <KTFooter />
      </footer>
    </div>

    <KTStickyToolbar v-if="toolbarDisplay" />
    <KTScrollTop />

    <PageLoader v-if="isLoading" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HtmlClass from "@/core/services/htmlclass.service";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeader from "@/view/layout/header/Header.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import PageLoader from "@/own/components/PageLoaderNew.vue";

export default {
  name: "AppLayoutNew",
  components: {
    KTAside,
    KTHeader,
    KTHeaderMobile,
    KTFooter,
    KTStickyToolbar,
    KTScrollTop,
    PageLoader,
  },
  computed: {
    ...mapGetters(["isAuthenticated", "layoutConfig"]),
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    toolbarDisplay() {
      return false;
    },
    isLoading() {
      return this.$store.getters.getPageLoading;
    },
  },
  beforeMount() {
    HtmlClass.init(this.layoutConfig());
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
  },
};
</script>

<style scoped lang="scss">
.layout {
  display: grid;
  grid-template-columns: auto 1fr;
  height: 100vh;
  background-color: #eef0f8;
  transition: filter 0.3s ease-in-out;
  overflow: hidden;

  &--loading {
    filter: blur(2px) brightness(0.55);
  }
}

.layout__sidebar {
  grid-column: 1;
  height: 100%;
  overflow-y: auto;
}

// Desktop only: below this breakpoint the theme's offcanvas mobile drawer
// (position: fixed, slid in/out via .aside-on) must stay in control.
@media (min-width: 992px) {
  ::v-deep .aside {
    position: static !important;
    height: 100%;
  }
}

::v-deep .header {
  position: static !important;
  width: 100% !important;
}

.layout__main {
  grid-column: 2;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.layout__header {
  flex: 0 0 auto;
}

.layout__content {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 6.1rem 1rem 0.5rem 1rem;
}

@media (min-width: 992px) {
  .layout__content {
    padding: 1.1rem 1rem 0.5rem 1rem;
  }
}

.layout__content-app {
  height: 100%;
}

::v-deep .layout__content-app .v-application--wrap {
  min-height: 0;
  height: 100%;
}

.layout__footer {
  flex: 0 0 auto;
}
</style>
